import jQuery from 'jquery'

const [w,d] = [window,document]

const $ = w.jQuery = jQuery

const _Ready = {
  ytscript: new $.Deferred,
  movie: new $.Deferred
};


const registCookie = name => {
  if(document.cookie.indexOf(`${name}`) != -1) return false
  document.cookie = `${name}=true;`
}
const existCookie = name => (document.cookie.indexOf(name) != -1)

$.extend({
  wait: function(duration){
      var dfd = $.Deferred();
      setTimeout(dfd.resolve, duration);
      return dfd;
  }
});

export default () => {

  // YTplayer の読み込み
  // ((s,p) => {
  //   const tag = document.createElement(s)
  //   const firstScriptTag = document.getElementsByTagName('script')[0]
  //   tag.src = p
  //   firstScriptTag.parentNode.insertBefore(tag, null)
  //   tag.onload = () => _Ready.ytscript.resolve()
  // })('script', '/assets/js/vendor/jquery.mb.YTPlayer.min.js')

  d.documentElement.classList.add('loading');

  const bg_init = () => {

    // d.documentElement.classList.add('background-black')

    const mv = d.querySelector('.p-home-bg__mov')
    mv.addEventListener('loadeddata',()=> _Ready.movie.resolve(mv))

  }

  d.addEventListener('DOMContentLoaded',bg_init)
  // _Ready.ytscript.done(bg_init)

  const loadingLayer = () => {
    // loading
    const $loading = $(`
      <div class="p-loading">
        <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
      </div>
    `)
    $loading.appendTo('body')
    
    $.when(
      _Ready.movie,
      $.wait(0)
    ).done(() => {
      d.documentElement.classList.remove('loading')
      d.querySelector('.p-home-bg__mov').play()
      setTimeout(() => $loading.remove(),500)
    })
  }
  d.addEventListener('DOMContentLoaded',loadingLayer)
}